import { Component } from '@theme/component';
import { scrollTo } from '@theme/scroll-container';

/**
 * A custom element that scrolls the page's scroll container back to the top.
 */
export class BackToTopComponent extends Component {
  /**
   * Scrolls the page scroll container to the top.
   *
   * @param {Event} event - The click event.
   */
  scrollToTop(event) {
    event.preventDefault();
    scrollTo({ top: 0, behavior: 'smooth' });
  }
}

if (!customElements.get('back-to-top-component')) {
  customElements.define('back-to-top-component', BackToTopComponent);
}
